import clsx from "clsx";
import React, { ReactNode } from "react";

interface RadioInputProps {
    value?: any;
    name?: string;
    checked: boolean;
    disabled?: boolean;
    children: ReactNode;
    className?: string;
    classNames?: { input: string };
    onChange: (e: any) => void;
    hideRadio?: boolean;
}

export const RadioInput = ({
    value,
    checked,
    disabled = false,
    name,
    children,
    className,
    onChange,
    classNames,
    hideRadio = false,
}: RadioInputProps) => {
    const inputClassName = disabled ? "!bg-gray-lighter" : "cursor-pointer";
    return (
        <label className={clsx("flex w-fit items-center", className)} data-testid="radio-input-label">
            <input
                checked={checked}
                disabled={disabled}
                value={value}
                type="radio"
                className={clsx(
                    "mr-1",
                    classNames?.input,
                    disabled && checked ? "opacity-80" : inputClassName,
                    hideRadio && "mr-0 hidden",
                )}
                name={name}
                onChange={onChange}
            />
            <span>{children}</span>
        </label>
    );
};
